<script setup>
import IconArrowUpRight from "@components/icons/ArrowUpRight.vue";
import Button from "@components/Button.vue";
import PanelTabs from "@components/explore/PanelTabs.vue";
import PanelFooter from "@components/explore/PanelFooter.vue";

import { useGlobalStore } from "@stores/global";
import { useGlobeStore } from "@stores/globe";
import { useExpediaStore } from "@stores/expedia";

const globalStore = useGlobalStore();
const globeStore = useGlobeStore();
const expediaStore = useExpediaStore();
const GET_STARTED_PAGES = ["explore", "achievements", "settings"];

function watchAd() {
    globalStore.openModal("exploreIntro", { bare: true });
}
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="
                globalStore.panelActive('getStarted') &&
                !globeStore.selectedCountry &&
                GET_STARTED_PAGES.includes(globalStore.activePage)
            "
            class="get-started bg-marine-800 border-marine-500 relative isolate flex flex-col justify-between border-r p-6 max-lg:justify-start max-lg:gap-6 max-lg:border-r-0"
            :class="{
                'max-lg:hidden':
                    globalStore.activePage === 'explore' &&
                    globalStore.mobilePanel !== 'getStarted',
            }"
        >
            <Button
                class="watch-ad"
                className="absolute bottom-full left-0 h-[38px] min-h-0! w-fit tracking-[0.12px]"
                @click="watchAd"
            >
                Watch the ad
            </Button>

            <PanelTabs />

            <div
                class="border-marine-500 flex flex-col gap-2.5 lg:gap-8 lg:border-b lg:pb-7.5"
                :class="{
                    'max-lg:h-[180px] max-lg:overflow-y-auto':
                        globalStore.activePage === 'explore',
                }"
            >
                <p
                    class="h5 leading-[0.9] font-bold uppercase max-lg:text-[28px]"
                >
                    Go places
                    <br />
                    <span class="font-extrabold text-yellow-400">
                        like ishowspeed
                    </span>
                </p>
                <p class="body-sm">
                    <a
                        :href="expediaStore.href('')"
                        target="_blank"
                        class="text-white underline"
                        >Book a trip today</a
                    >
                    to win a chance to meet Speed. Follow
                    <span class="text-yellow-400 underline">@Expedia</span>

                    on
                    <a
                        href="https://www.instagram.com/expedia/"
                        target="_blank"
                        class="underline"
                        >Instagram</a
                    >
                    and

                    <a
                        href="https://www.tiktok.com/@expedia"
                        target="_blank"
                        class="underline"
                        >TikTok</a
                    >
                    for updates.
                </p>
            </div>
            <PanelFooter />
            <IconArrowUpRight
                class="absolute top-4 right-4 h-5 text-yellow-400 max-lg:hidden"
            />
        </div>
    </Transition>
</template>

<style scoped>
.get-started {
    grid-column: 1 / 7;
    grid-row: -5 / -1;
    z-index: 2;
}

@media (max-width: 1024px) {
    .get-started {
        grid-column: 1 / -1;
        grid-row: -2 / -1;
        align-self: end;
    }
}

.watch-ad {
    clip-path: polygon(
        0 0,
        100% 0,
        100% calc(100% - 8px),
        calc(100% - 8px) 100%,
        0 100%
    );
}
</style>
